/* 渠道类型 */
export const CHANNEL_TYPE_BANK = 0 // 银行
export const CHANNEL_TYPE_BROKER = 1 // 券商
export const CHANNEL_TYPE_PERSONAL_BIG_ORDER = 3 // 个人大单
export const CHANNEL_TYPE_COMPANY_GRADE_A = 4 // 省公司达标-提前完成
export const CHANNEL_TYPE_COMPANY_GRADE_B = 5 // 省公司达标-再接再厉
export const CHANNEL_TYPE_BROKEN_SALES = 6 // 销量破整
export const CHANNEL_TYPE_FENGRONG = 7 // 丰融大单



// WEBPACK FOOTER //
// ./src/constants/GlobalConstants.js